import { call, put, fork, takeLatest } from 'redux-saga/effects';
import { requestUserDetails } from '../requesters/userRequester';
import { receiveUserDetails } from '../actions/userActions';
import { reqFeatures } from '../actions/featureActions';
import { REQUEST_USER_DETAILS } from '../constants/actionTypes';
import { FEATURE_LIST } from '../constants/featureFlags';

/**
 * Calls requestUserDetails to fetch the proxy user's details, then dispatches
 * receiveUserDetails with the results
 * @param {Object} action
 * @return {void}
 */
export function* getUserDetails(action) {
  const userDetails = yield call(requestUserDetails, action.id, true);
  yield put(receiveUserDetails(userDetails));

  if (action.shouldFetchFeatures) {
    yield put(reqFeatures(FEATURE_LIST, userDetails.id, userDetails.email));
  }
}

/**
 * Waits for the return of the REQUEST_USER_DETAILS action event and calls
 * the getUserDetails saga
 * @return {void}
 */
export function* getUserDetailsWatcher() {
  yield takeLatest(REQUEST_USER_DETAILS, getUserDetails);
}

/**
 * Uses fork to start multiple watchers in parallel
 * @return {void}
 */
export default function* rootSaga() {
  yield fork(getUserDetailsWatcher);
}
